<template>
  <div class="modal fade show d-block" tabindex="-1" role="dialog" aria-labelledby="modalTitle" aria-modal="true">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Linki</h5>
          <button type="button" class="btn-close" @click="$emit('close')"></button>
        </div>

        <div class="modal-body">
          <div class="mb-4">
            <label class="form-label">Nowy link</label>
            <div class="input-group">
              <input v-model="newLink" type="text" class="form-control" placeholder="https://...">
              <button class="btn btn-success" @click="addLink" :disabled="loading || !newLink">
                Dodaj
              </button>
            </div>
            <div v-if="errorMessage" class="text-danger mt-2">
              {{ errorMessage }}
            </div>
          </div>

          <div v-if="orderList.order_links?.length">
            <label>Linki dodane do zamówienia:</label>
            <ul class="list-group mt-2">
              <li v-for="link in orderList.order_links" :key="link.id" class="list-group-item d-flex justify-content-between align-items-center">
                <a class="text-primary" :href="link.url" target="_blank">
                  {{ shortenFileName(link.url,40) }}
                </a>
                <button v-if="canRemove" class="btn btn-danger btn-sm" @click="removeLink(link)">
                  Usuń
                </button>
              </li>
            </ul>
          </div>

          <div v-else class="text-muted">
            Brak dodanych linków.
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="$emit('close')">
            Zamknij
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    orderList: Object,
    canAdd: {
      type: Boolean,
      default: true
    },
    canRemove: {
      type: Boolean,
      default: true
    }
  },

  emits: [
    "refresh",
    "added-success",
    "added-error",
    "close"
  ],

  data() {
    return {
      newLink: "",
      loading: false,
      errorMessage: ""
    };
  },

  methods: {
    shortenFileName(url, maxLength = 100) {
      if (!url) return "";
      if (url.length <= maxLength) return url;
      return url.substring(0, maxLength) + "...";
    },

    async addLink() {
      if (!this.newLink) return;
      this.loading = true;
      this.errorMessage = "";

      try {
        const response = await axios.post(`/order-lists/${this.orderList.id}/links`, {
          url: this.newLink
        });

        if (!this.orderList.order_links) {
          this.orderList.order_links = [];
        }

        this.orderList.order_links.push(response.data);
        this.newLink = "";
        this.$emit("refresh");
        this.$emit("added-success");
      } catch (e) {
        if (e.response?.status === 422) {
          this.errorMessage = e.response.data.message;
        } else {
          this.errorMessage = "Nie udało się dodać linku.";
        }
        this.$emit("added-error");
      } finally {
        this.loading = false;
      }
    },

    async removeLink(link) {
      if (!confirm("Usunąć link?")) return;

      try {
        await axios.delete(`/order-list-links/${link.id}`);
        this.orderList.order_links = this.orderList.order_links.filter(l => l.id !== link.id);
        this.$emit("refresh");
      } catch (e) {
        alert("Nie udało się usunąć linku.");
      }
    }
  }
}
</script>

<style scoped>
.modal.show {
  display: block;
  background: rgba(0,0,0,.5);
}
</style>